<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">Your occupation</h1>
      <p class="bodycopy"></p>
    </div>
    <form @submit.prevent>
      <OccupationField @inputValueUpdate="updateOccupation" />

      <ButtonBase
        :isDisabled="
          occupationStore.formHasErrors || globalStore.getIsFormLoading
        "
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Submit my details
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useOccupationStore } from "@/stores/forms/occupationFormStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useApiHelpers from "@/composables/api/helpers";
import useCustomerActions from "@/composables/api/useCustomerActions";

import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import OccupationField from "@/components/ui/inputs/OccupationField.vue";

const router = useRouter();
const globalStore = useGlobalStore();
const occupationStore = useOccupationStore();

const { postRequest } = useApiHelpers();
const { fetchCustomerId } = useCustomerActions();
const identityQueueStore = useIdentityQueueStore();

const form = ref({
  occupation: occupationStore.form.occupation.value || "",
});

const updateOccupation = (inputData) => {
  const field = Object.keys(inputData)[0];
  const value = Object.values(inputData)[0];

  form.value[field] = value;
};

const handleFormSubmit = async () => {
  const formData = {
    documentType: "occupation",
    occupation: form.value.occupation,
  };

  globalStore.setIsFormLoading(true);

  postRequest("customers/occupation", formData, () => {
    router.push(identityQueueStore.getNextIdentityRoute);
  });
};
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
